/**
 * TUT-192 — o ponto ÚNICO de vocabulário do front.
 *
 * Pedido do cliente: "Organizações" vira "Clientes" — mas SÓ nos rótulos e
 * textos visíveis. A API, os tipos, o banco e as rotas seguem falando
 * `organization`/`/organizacoes`: são ~2.263 ocorrências de `organiza*` no
 * repositório e ~60 textos visíveis; renomear o modelo por causa do rótulo
 * seria o find/replace que quebra `kanban_boards.scope = 'ORGANIZATION'`
 * (que significa "do escritório", não "do cliente") em silêncio.
 *
 * Este módulo existe para a PRÓXIMA troca de vocabulário custar uma linha.
 * Texto visível novo que fale da entidade importa daqui; escrever
 * "Organização" à mão num JSX é reintroduzir a divergência que o pedido veio
 * apagar. `kind: ORGANIZATION | UNIT` já é Matriz/Filial na tela — os rótulos
 * de vínculo não mudam.
 *
 * Resíduo declarado (backlog TUT-192): as exceções do Nest continuarão
 * dizendo "Organização" até a API mudar — mensagem de erro do servidor não é
 * rótulo do front, e renomear a API de contrabando está fora do recorte.
 */
export const rotuloCliente = {
  /** A entidade, no singular: "Cliente". */
  singular: "Cliente",
  /** O plural que nomeia tela, menu e coluna: "Clientes". */
  plural: "Clientes",
  /** Em meio de frase: "o cliente escolhido". */
  singularMinusculo: "cliente",
  /** Em meio de frase: "os clientes do escritório". */
  pluralMinusculo: "clientes",
} as const;
